import { render } from "./signUpForMobile.vue?vue&type=template&id=c96c7a5e&scoped=true"
import script from "./signUpForMobile.vue?vue&type=script&lang=js"
export * from "./signUpForMobile.vue?vue&type=script&lang=js"

import "@/assets/css/signUp.css?vue&type=style&index=0&id=c96c7a5e&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c96c7a5e"]])

export default __exports__